
import {useHead} from '@vueuse/head'
import YieldCheckDash from "./yieldcheck/YieldCheckDash.vue"
import SidebarLayout from '../layouts/SidebarLayout.vue'
import {computed, defineComponent, reactive} from "vue";

import VButton from '../components/base/button/VButton.vue'
import {useToggle} from '@vueuse/core'
import {mapState} from "vuex";

export default defineComponent({
  name: 'Login',
  components: {
    VButton,
    YieldCheckDash,
    SidebarLayout
  },
  setup() {
    const siteData = reactive({
      title: `JB Drax Honoré Strategies`
    })
    useHead({
// Can be static or computed
      title: computed(() => siteData.title),
    })
    useToggle(false)
  },
  data() {
    return {
      LoggedIn: {
        LoggedIn: localStorage.isLoggedIn
      }
    }
  },
  computed: {
    ...mapState(['user'])
  },

})


